export const APPROVING = 'Please wait as your Approval is being Confirmed.';
export const TRANSACTION_PENDING = 'Please wait as your Transaction is being Confirmed.';
export const SUCCESS = 'Your Transaction has been Confirmed';
export const SIGNATURE_PENDING = 'Please confirm message signature.';

export const INSUFFICIENT_BALANCE = 'Insufficient Balance!';

export const VERIFY_REFERRAL = 'Please wait as your referral is being verified';
export const REFERRAL_MIN_LENGTH = 'Minimum character is 6!';
export const EXISTING_REFERRAL = 'Referral code already exists!';
export const SIGN_REFERRAL = 'Please sign your referral code';
export const REFERRAL_CREATED = 'Your customized referral code has been created!';

export const ORDER_SUBMIT_PENDING = 'Submitting your order!';
export const ORDER_PLACED = 'Your Order has been placed!';
export const ORDER_CANCELLED = 'Your Order has been cancelled!';

export const SLIPPAGE_CONFIGURED = 'Slippage set!';
export const SLIPPAGE_DEFAULT_CONFIGURED = 'Slippage set to default!';
